/**
 * Wolof (owner, 2026-10-07): "seulement les présentations ... et le reste en
 * français". Each presentation table gets a `wo`: its French table with the
 * paths below in Wolof, as the owner validated them on the review page (each
 * line of the home and service pages checked one by one, six corrected; the
 * rest approved with "J'ai tout validé"). Every word not listed stays French,
 * and the screens drawn inside the pages keep the site's French labels.
 *
 * A path names a key of the French table, a number an array index. Where the
 * French value is a function (a count, a first name), "{n}" or "{name}" in
 * the Wolof stands for its argument.
 */

export const WOLOF = {
  pageTitles: { home: "Toukky — Fan nga bëgg dem ?" },
  greeting: "Fan nga bëgg dem, {name} ?",
  partnerGreeting: "Na nga def ?",
  home: {
    "recent.title": "Sa wut yu mujj",
    "destinations.title": "Wërël àddina si",
    "destinations.moreStays": "Dalukaay yi ci Toukky",
    "trust.title": "Réserver ak Toukky",
    "trust.manage.title": "Sa réservation, su fekkee amuloo compte sax",
    "trust.manage.body": "Gis ko ak sa e-mail ak sa nimero réservation Toukky.",
    "trust.manage.link": "Saytu sama réservation",
    "trust.support.title": "Ndimbal ci sa réservation",
    "trust.support.body": "Bindal sunu Ndaw ak sa nimero réservation, tontu bi dina ñëw ci sa e-mail.",
    "trust.support.link": "Jokkoo ak sunu Ndaw",
    "newsletter.title": "Ay xalaat ngir sa tukki yi di ñëw",
    "newsletter.sub": "Ay xalaat ci tukki ak xibaar yu bees yu Toukky, ci e-mail.",
    "newsletter.cta": "Bindu",
    "newsletter.done": "Jërëjëf, bindu nga.",
  },
  hotels: {
    "headline": "Bépp tukki am na fa mu dal",
    "sub": "Benn guddi walla ay fan : wutal fu ngay dal fu la neex.",
    "heroAccent": "fa mu dal",
  },
  flights: {
    "headline": "Àddina si, ci benn roppalaan",
    "sub": "Méngaleel roppalaan yi te tànnal sa tukki bu ci topp.",
    "heroAccent": "ci benn roppalaan",
  },
  flightHotel: {
    "headline": "Sa tukki ngi tàmbali",
    "sub": "Wutal fu ngay dal, ba noppi sa roppalaan. Réserver leen benn-benn.",
    "heroAccent": "tàmbali",
  },
  cars: {
    "heroTitle": "Sa yoon, sa doxin",
    "heroSub": "Tànnal oto bu la neex ngir say yoon, say bés ak li nga bëgg.",
    "heroPoints.0": "Méngaleel oto yi ak seen njëgu bés",
    "heroPoints.1": "Waxal fu ngay jëlee oto bi ak say bés",
    "heroPoints.2": "Xoolal li oto bi am ak sàrti luwe bi",
    "heroAccent": "sa doxin",
  },
  attractions: {
    "heroTitle": "Ay xew-xew",
    "heroSub": "Visites ak xew xew : tànnal saa yi di rafetal sa tukki.",
    "heroAccent": "xew-xew",
  },
  taxis: {
    "heroTitle": "Ci aéroport bi ba fa ngay dem",
    "heroSub": "Waajal sa agsi : wutal sa transfert bu jóge ci aéroport bi.",
    "heroAccent": "fa ngay dem",
  },
  tripGroupe: {
    "hero.title": "Tukki bu bari ay nit, benn waxtaan.",
    "hero.lead": "Wooleel say mbokk ak say xarit, séddoo roppalaan yi ak dalukaay yi ngeen gis ci Toukky, te ngeen dogal ànd. Bu ñi ëpp nangoo, ki sos groupe bi dina réserver ngir ñépp.",
    "hero.badgeFigure": "Ba 15 %",
    "hero.badgeText": "wàññi ngir groupe bi ci offre bi ngeen tànn ànd*",
    "hero.create": "Sos sama Trip Groupe",
    "hero.how": "Naka lay doxe",
    "hero.reassure.0": "Bokk ci groupe du la takk dara",
    "hero.reassure.1": "Vote du réserver dara",
    "hero.note": "Misaal rekk la : tur yi, bés yi ak njëg yi, ay misaal lañu.",
    "hero.alt": "Misaal : waxtaanu benn groupe bu 8 nit ci telefon. Ñu séddoo ci benn dalukaay ci Lisbonne ; 6 ci ñoom vote nañu te ñi ëpp nangu nañu.",
    "steps.kicker": "Naka lay doxe",
    "steps.title": "Ñeenti étape, benn tukki.",
    "steps.intro": "Waxtaan yu gudd yu tasaaroo, jeex na : groupe bi yépp dañuy waajal tukki bi ci benn bérab, te ku nekk am na kàddoom.",
    "steps.items.0.title": "Sosal sa groupe",
    "steps.items.0.body": "Say xibaar ak turu tukki bi, ci benn formulaire rekk : sa Trip Groupe pare na.",
    "steps.items.0.alt": "Formulaire bi ñuy sose, ak turu tukki bi.",
    "steps.items.1.title": "Wooleel say mbokk",
    "steps.items.1.body": "Copier lien bi te yónnee ko ci WhatsApp walla ci message. Bokk ci groupe bi du la takk dara.",
    "steps.items.1.alt": "Lien bu sutura bi ngir woo nit, ak bouton bi ngir copier ko.",
    "steps.items.2.title": "Tànnleen ànd",
    "steps.items.2.body": "Séddool roppalaan walla dalukaay ci benn bës, waxtaanleen, ba noppi voteel waaw walla déedéet ci bépp offre.",
    "steps.items.2.alt": "Bouton « Partager avec mon voyage », ak vote « Oui » ak « Non » ci benn offre bu ñu séddoo.",
    "steps.items.3.title": "Réserver te dem",
    "steps.items.3.body": "Bu ñi ëpp votee waaw, ki sos groupe bi dina réserver offre bi ngir groupe bi. Dem rekk a des.",
    "steps.items.3.alt": "Ñi ëpp nangu nañu, ak bouton « Réserver cette offre ».",
    "inside.kicker": "Ci sa groupe",
    "inside.title": "Lépp ngir dogal ànd, ci benn bérab.",
    "inside.intro": "Waxtaan bi, offre yi ñu séddoo ak vote yi, ci groupe bi lañu nekk, ci telefon walla ci ordinateur.",
    "inside.share.title": "Séddoo benn offre ci benn bës",
    "inside.share.body": "Loupe bi ci waxtaan bi dafay yóbbu la nga wut ngir groupe bi. Ci roppalaan walla dalukaay, « Partager dans… » dafay yónnee ko ci saa si ci waxtaan bi, ak bés yi ak njëg li ci benn nit.",
    "inside.share.alt": "Benn roppalaan ci résultats yi, bi ñuy wut ngir groupe bi, ba noppi roppalaan boobu ñu séddoo ko ci waxtaan bi.",
    "inside.vote.title": "Ku nekk vote, ñi ëpp ñoo dogal",
    "inside.vote.body": "Waaw walla déedéet, ci bépp offre. Bu lu ëpp genn-wàllu groupe bi waxee waaw, « Majorité favorable » dina feeñ te ki sos groupe bi mën na réserver. Vote du réserver dara te du may benn fey.",
    "inside.vote.alt": "Benn offre bu ñi ëpp nangu : ki sos groupe bi dafay gis bouton « Réserver cette offre », ñeneen ñi gis benn message.",
    "inside.vote.organizerSees": "Ki sos groupe bi dafay gis",
    "inside.vote.othersSee": "Ñeneen ñi dañuy gis",
    "inside.voice.title": "Note vocale, bu waxe gënee yomb",
    "inside.voice.body": "Ci site bi, bësal micro bi, wax, yónnee : note bu weesuwul ñaari minit, ku nekk déglu ko bu ko neexee.",
    "inside.voice.alt": "Benn note vocale bu ñu jot, pare ngir ñu déglu ko, ak benn enregistrement buy dox.",
    "inside.expired.title": "Offre bi jeex na ? Wutaatal",
    "inside.expired.body": "Offre yu compagnie yi duñu yàgg. Bu roppalaan bu ñu séddoo jeexee, njëgam bu jëkk dina des ngir waxtaan bi, te « Rechercher à nouveau » dafay wutaat ak aéroport yooyu, bés yooyu ak limu tukkikat boobu.",
    "inside.expired.alt": "Offre roppalaan bu jeex, ak bouton « Rechercher à nouveau ».",
    "inside.bubble.title": "Groupe bi ngi la topp bi ngay wut",
    "inside.bubble.body": "Bu nga bokkee ci benn groupe, benn bulle dina nekk ci sa wet ci pages yu Toukky, ak limu message yi nga jàngagul ci xonq. Ci ordinateur, dafay ubbi benn palanteer bu ndaw ci wetu page bi ; ci telefon, waxtaan bi dafay fees écran bi. Toxal ko : dafay dem ci wet gi gën a jege.",
    "inside.bubble.alt": "Ci ordinateur, waxtaan bi ubbiku ci benn palanteer bu ndaw ci wetu benn page séjours ; ci telefon, bulle bi ak ñetti message yi ñu jàngagul.",
    "inside.bubble.desk": "Ci ordinateur",
    "inside.bubble.phone": "Ci telefon",
    "discount.kicker": "Wàññi ngir groupe",
    "discount.title": "Ba 15 % wàññi ci offre bi ngeen tànn ànd.",
    "discount.body": "Bu ki sos groupe bi réserveree ci biir groupe bi offre bi ñi ëpp tànn, wàññi bi dafay dox ci boppam. Bu ngeen gënee bare ci tukki bi, wàññi bi gën a mag*.",
    "discount.list.0": "Roppalaan walla dalukaay bu ñu séddoo ci groupe bi",
    "discount.list.1": "Bu ñi ëpp ci groupe bi tànn",
    "discount.list.2": "Bu ki sos groupe bi réserver, ak « Réserver cette offre »",
    "discount.list.3": "Limu xaalis bi dina feeñ ci paiement bi, balaa ngay fey",
    "discount.caption": "Misaal ci paiement bi, ngir 8 tukkikat.",
    "discount.alt": "Récapitulatif paiement bi : njëg bu jëkk bi, wàññi Trip Groupe bi ci wert, ba noppi total bi.",
    "trust.kicker": "Ci kóolute",
    "trust.title": "Ku nekk am na kàddoom.",
    "trust.items.0.title": "Bokk du la takk dara",
    "trust.items.0.body": "Bokk ci groupe bi du la takk ci benn réservation walla benn fey.",
    "trust.items.1.title": "Sa profil, sa sutura la",
    "trust.items.1.body": "Ñi bokk ci groupe bi dañuy gis sa tur rekk. Sa xibaar yu dëgg, sa bésu juddu ak sa nimero dañuy des ci sutura.",
    "trust.items.2.title": "Lien bu ngay saytu",
    "trust.items.2.body": "Ki sos groupe bi moo tànn ba kañ la lien bi di dox, te mën na ko dindi saa yu ko neexee.",
    "trust.items.3.title": "Fey bu wóor",
    "trust.items.3.body": "Fey bi dafay jaar ci benn plateforme bu wóor, te confirmation bi dina ñëw ci e-mail.",
    "faq.kicker": "Laaj yi ñuy faral di laaj",
    "faq.title": "Lu baax nga xam",
    "faq.items.0.q": "Ndax bokk ci groupe dina ma takk ci fey ?",
    "faq.items.0.a": "Déedéet. Bokk ci groupe bi du la takk ci benn réservation walla benn fey : danga waxtaan, danga vote, te vote du réserver dara.",
    "faq.items.1.q": "Kan moo koy réserver ngir groupe bi ?",
    "faq.items.1.a": "Ki sos groupe bi. Bu ñi ëpp votee waaw ci benn offre, mu réserver ko ci biir groupe bi te fey ko ni bépp réservation ci Toukky.",
    "faq.items.2.q": "Kan moo mën a woo nit ci groupe bi ?",
    "faq.items.2.a": "Ki sos groupe bi. Moo sos lien bi, tànn ba kañ lay dox te mën na ko dindi. Ki ñu woo dina bokk ci groupe bi bu duggee ci compte am.",
    "faq.items.3.q": "Lan lañu mën a séddoo ci groupe bi ?",
    "faq.items.3.a": "Roppalaan yi ak dalukaay yi ngeen gis ci Toukky, ak bouton « Partager avec mon voyage ».",
    "faq.items.4.q": "Lan moo war ngir sos walla bokk ci groupe ?",
    "faq.items.4.a": "Benn compte Toukky ak sa profil tukkikat bu mat : tur, sant, e-mail, telefon ak bésu juddu.",
    "faq.itemDiscount.q": "Naka la wàññi ngir groupe di doxe ?",
    "faq.itemDiscount.a": "Bu ki sos groupe bi réserveree ci biir groupe bi offre bi ñi ëpp tànn, wàññi ngir groupe dina dox su ngeen tollee 3 tukkikat ba ci kaw, ba 15 % ci limu tukkikat yi. Limu xaalis bi dañu koy waññ te wone ko bi ngay fey*.",
    "band.title": "Sa tukki bu ci topp, fii lay tàmbalee.",
    "band.text": "Sosal sa Trip Groupe te woo say mbokk.",
    "band.textDiscount": "Sosal sa Trip Groupe, woo say mbokk te denc ba 15 % ànd*.",
    "noteDiscount": "* Wàññi ngir groupe su ngeen tollee 3 tukkikat ba ci kaw, ba 15 % ci limu tukkikat yi, ci roppalaan walla dalukaay bu ñu séddoo ci groupe bi, bu ñi ëpp tànn te ki sos groupe bi réserver ko ci biir groupe bi. Limu xaalis bi dina feeñ ci paiement bi.",
  },
  partnersLanding: {
    "perks.0.0": "Dajeel ak tukkikat yu Toukky",
    "perks.0.1": "Sa offre ci kanam tukkikat yiy réserver roppalaan, otel ak oto ci Toukky.",
    "perks.1.0": "Dossier bu ñu saytu",
    "perks.1.1": "Yónneel documents yi ñu laaj te topp ni ñuy saytoo sa compte ak say annonces.",
    "perks.2.0": "Xaalis bu leer",
    "perks.2.1": "Toppal sa xaalis ak fu bépp versement tollu, réservation bu nekk.",
    "teaser.say.all.0": "Li nga gën a mën, war na ñu gis ko.",
    "teaser.say.all.1": "Ci Toukky, ay milyoŋi tukkikat, fépp ci àddina, mën nañu gis sa offre te réserver ko.",
    "teaser.say.property.0": "Dalal àddina si ci sa kër.",
    "teaser.say.property.1": "Otel, appartement, villa walla maison d'hôtes : ay milyoŋi tukkikat mën nañu gis sa kër te réserver fa seen séjour.",
    "teaser.say.vehicles.0": "Say oto am nañu ndaje ak àddina si.",
    "teaser.say.vehicles.1": "Agence, flotte walla boroom oto : ay milyoŋi tukkikat mën nañu gis say oto te luwe leen ngir wéy seen tukki.",
    "teaser.say.taxis.0": "Nekkal muuñ mu jëkk ci seen tukki.",
    "teaser.say.taxis.1": "Ay milyoŋi tukkikat mën nañu réserver seen yoon ak yow balaa ñuy wàcc sax, ak njëg bu wóor, jóge walla jëm ci aéroport bi.",
    "teaser.say.attractions.0": "Séddool ak àddina si li nga sopp.",
    "teaser.say.attractions.1": "Visite, doxantu, aventure walla lekk yu neex : ay milyoŋi tukkikat mën nañu gis sa activité te réserver seen palaas.",
    "teaser.choose": "Li ngay jox",
    "teaser.start": "Yégle sama offre",
    "teaser.how": "Naka lay doxe",
    "teaser.factsLabel": "Toukky ci lu gàtt",
    "teaser.languages": "{n} làkk",
    "teaser.currencies": "{n} devises",
    "teaser.world": "Tukkikat fépp ci àddina",
    "teaser.prices": "Say njëg, ñu wone leen ci",
    "teaser.pause": "Taxawal animation bi",
    "teaser.play": "Tàmbaliwaat animation bi",
    "families.property": "Dalukaay",
    "families.vehicles": "Oto",
    "families.taxis": "Transferts",
    "families.attractions": "Activités",
    "doors.title": "Lan nga bëgg a jox ?",
    "doors.lead": "Tànnal fu ngay tàmbalee. Benn compte mën na jox ñeent yépp ginnaaw gi.",
    "doors.cards.property.0": "Dalukaay",
    "doors.cards.property.1": "Otel, appartement, villa, maison d'hôtes, auberge ak resort.",
    "doors.cards.property.2": "Yégle sama dalukaay",
    "doors.cards.vehicles.0": "Luwe oto",
    "doors.cards.vehicles.1": "Agence, flotte ak boroom oto yuy liggéeyal seen bopp.",
    "doors.cards.vehicles.2": "Yégle samay oto",
    "doors.cards.taxis.0": "Transfert aéroport",
    "doors.cards.taxis.1": "Berline, SUV, monospace walla minibus, ak njëg bu wóor te ci réservation.",
    "doors.cards.taxis.2": "Yégle samay transfert",
    "doors.cards.attractions.0": "Activités",
    "doors.cards.attractions.1": "Visite ak guide, àll ak tool, aventure, lekk yu neex ak activité ci géej.",
    "doors.cards.attractions.2": "Yégle sama activité",
    "how.title": "Naka lay doxe",
    "how.lead": "Ñeenti étape, ci sa doxin. Toukky dafay saytu bépp annonce balaa muy génn ci internet.",
    "how.steps.0.0": "Sosal sa compte",
    "how.steps.0.1": "Nit walla entreprise : benn compte rekk ngir say dalukaay, say oto, say taxi ak say activité.",
    "how.steps.1.0": "Waajal sa annonce",
    "how.steps.1.1": "Yoon bu ñu la wone, étape ak étape. Dencal saa su la neexee te dellusi fa nga tolloon.",
    "how.steps.2.0": "Yónnee ko Toukky",
    "how.steps.2.1": "Seet bu jëkk balaa ngay yónnee, ba noppi Toukky saytu sa dossier ak sa annonce.",
    "how.steps.3.0": "Dalal say tukkikat",
    "how.steps.3.1": "Sa annonce génn na, say bés ubbi nañu : réservation yi, message yi ak sa xaalis, ci sa espace partenaire ngay topp lépp.",
    "tools.title": "Espace bu ñu defar ngir sa liggéey",
    "tools.lead": "Bépp liggéey am na ay jumtukaayam. Ñoom ñépp bokk nañu lii : réservations, messages, finances ak avis.",
    "tools.tablist": "Sa liggéey",
    "tools.dayTitle": "Bés bi, ci say réservation",
    "tools.daySub": "Li ngay def ci sa espace.",
    "tools.panels.property.feats.0.0": "Say néeg, benn-benn",
    "tools.panels.property.feats.0.1": "Bépp néeg ak salon bi, ak seen lal ak seen nataal, ngir appartement, kër walla villa.",
    "tools.panels.property.feats.1.0": "Sa sàrtu annulation",
    "tools.panels.property.feats.1.1": "Flexible, modérée walla non remboursable. Dafay dox ginnaaw 24 waxtu yi topp bépp réservation.",
    "tools.panels.property.feats.2.0": "Sa adrees, ñu aar ko",
    "tools.panels.property.feats.2.1": "Benn gox ci carte bi ngir dalukaay bu sutura : adrees bu wóor bi, tukkikat yu ñu confirmer rekk ñoo koy jot.",
    "tools.panels.property.feats.3.0": "Sa wàllu kër, ak say kàddu",
    "tools.panels.property.feats.3.1": "Ba 7 bérab yu jege sa établissement : transport, tefes, restaurant, bitig.",
    "tools.panels.property.day.0.1": "Ak code agsi bu tukkikat bi, ngir dalukaay bu sutura.",
    "tools.panels.property.day.1.1": "Séjour bi jeex na.",
    "tools.panels.property.day.2.1": "Sa xaalis dina jàll ci versement.",
    "tools.panels.vehicles.feats.0.0": "Say sàrt, ñu nangu leen",
    "tools.panels.vehicles.feats.0.1": "Kilométrage, at yi dawalkat bi war a am, at yi mu am permis, essence : tukkikat bi dafay nangu lépp bi muy réserver.",
    "tools.panels.vehicles.feats.1.0": "Jox ak delloo",
    "tools.panels.vehicles.feats.1.1": "Code tukkikat bi moo tàmbali location bi. Bu oto bi dellusee, nga bind ni mu mel.",
    "tools.panels.vehicles.feats.2.0": "Sa assurance, ñu wone ko",
    "tools.panels.vehicles.feats.2.1": "Attestation bu Toukky nangu te bees dina feeñ ci sa annonce.",
    "tools.panels.vehicles.feats.3.0": "Beneen oto, ci gaaw",
    "tools.panels.vehicles.feats.3.1": "Duplique benn oto ci brouillon, ba noppi yokk ay nataalam ak ay documentam.",
    "tools.panels.vehicles.day.0.1": "Ak code tukkikat bi : location bi tàmbali na.",
    "tools.panels.vehicles.day.1.1": "Baax na, yàqu na, essence amul, yeex na : yaay wax ni oto bi mel.",
    "tools.panels.vehicles.day.2.1": "Sa xaalis dina jàll ci versement.",
    "tools.panels.taxis.feats.0.0": "Yoon yu am njëg bu wóor ak gox yi",
    "tools.panels.taxis.feats.0.1": "Yoon bu wóor bi moo jiitu gox bi, te bépp njëg dafay dox ci ñaari wàll yi.",
    "tools.panels.taxis.feats.1.0": "Yow yaay nangu bépp laaj",
    "tools.panels.taxis.feats.1.1": "Nangul walla bañ benn transfert ; bu nga bañee, nga wax lu tax.",
    "tools.panels.taxis.feats.2.0": "Lépp ngir bés bi",
    "tools.panels.taxis.feats.2.1": "Fan lañuy jëm, fu ñuy jëlee, fu ñuy wàccee, waxtu, roppalaan, passagers ak bagages.",
    "tools.panels.taxis.feats.3.0": "Réserver ci lu jiitu",
    "tools.panels.taxis.feats.3.1": "Dañuy réserver benn yoon lu néew lu néew 5 waxtu balaa mu dox : danga gis say liggéey di ñëw.",
    "tools.panels.taxis.day.0.1": "Yaay tontu bépp laaj.",
    "tools.panels.taxis.day.1.1": "Ak code tukkikat bi, bu nga nanguwee laaj bi.",
    "tools.panels.taxis.day.2.1": "Transfert bi jeex na : sa xaalis dina jàll ci versement.",
    "tools.panels.attractions.feats.0.0": "Waxtu yi ak palaas yi",
    "tools.panels.attractions.feats.0.1": "Bés, waxtu bu muy tàmbali, ni mu yàgge ak limu palaas yi ; mën nga leen soppi sax bu activité bi génnee.",
    "tools.panels.attractions.feats.1.0": "Palaas yi duñu weesu li ñu waajal",
    "tools.panels.attractions.feats.1.1": "Tukkikat yi dañuy gis palaas yi des ; waxtu bu fees, kenn mënatul koo réserver.",
    "tools.panels.attractions.feats.2.0": "Sa activité, ci leer",
    "tools.panels.attractions.feats.2.1": "Làkk yi ngay wax, li ci nekk, at yi ñu war a am ak fu ñuy dajee.",
    "tools.panels.attractions.feats.3.0": "Njëgu mag ak njëgu xale",
    "tools.panels.attractions.feats.3.1": "Benn njëg ngir mag, benn njëg ngir xale, ak njëg ci bépp waxtu su la neexee.",
    "tools.panels.attractions.day.0.1": "Ak code tukkikat bi : activité bi tàmbali na.",
    "tools.panels.attractions.day.1.1": "Yaay tëj activité bi.",
    "tools.panels.attractions.day.2.1": "Sa xaalis dina jàll ci versement.",
    "tools.commonTitle": "Ci liggéey yépp",
    "money.title": "Sa xaalis, réservation bu nekk.",
    "money.lead": "Fey bu tukkikat bi ak sa versement, ñaari étape yu wuute lañu. Sa espace dina la wone fu bépp xaalis tollu.",
    "money.buckets.0.0": "Xaalis buy ñëw",
    "money.buckets.0.1": "Réservation yu ñu fey te service bi jeexagul.",
    "money.buckets.1.0": "Versement yuy xaar",
    "money.buckets.1.1": "Xaalis buy xaar ñu bayyi ko, bu pare walla bu ñuy liggéeyal.",
    "money.buckets.2.0": "Ñu yónnee ko ba noppi",
    "money.buckets.2.1": "Versement yu ñu yónnee ba noppi.",
    "money.facts.0.0": "Ñu dogal ko ci réservation bi",
    "money.facts.0.1": "Sa xaalis dañu koy dogal bu réservation bi amee : soppi sàrt yi du soppi mukk réservation bu weesu.",
    "money.facts.1.0": "Benn ligne ci bépp réservation",
    "money.facts.1.1": "Bésu service bi, sa xaalis ak fu versement bi tollu, ci bépp réservation bu ñu fey.",
    "money.facts.2.0": "Xaalis bu ñu téye, ci wetam",
    "money.facts.2.1": "Xaalis bu ñu téye ngir seet ko, duñu ko mukk boole ak li ci des.",
    "trust.title": "Kóolute, ci ñaari wàll yi",
    "trust.lead": "Ay sàrt yu leer, yu mel ngir yow ak say tukkikat.",
    "trust.code.0": "Benn code ngir tàmbali",
    "trust.code.1": "Agsi ci dalukaay bu sutura, jox oto, tàmbali transfert walla tàmbali activité : tukkikat bi dina la jox code am. Benn yoon rekk lay dox, ci wetu bésu service bi.",
    "trust.verify": "Seet bu dëppoo ak yow",
    "trust.roles.0.1": "Kayitu identité ak selfie ci saa si, benn yoon rekk. Toukky du jot mukk nataalu say documents.",
    "trust.roles.1.1": "Registre du commerce ak justificatif d'adresse, Toukky dina leen saytu.",
    "trust.reviews.0": "Ay avis yu wóor",
    "trust.reviews.1": "Tukkikat bu service bi jeex rekk moo mën a bayyi avis. Yow nga koy tontu ci kanam ñépp, benn yoon, walla nga signaler ko.",
    "trust.chat.0": "Benn waxtaan ci bépp réservation",
    "trust.chat.1": "Mu ngi ubbiku bu fey bi amee, mën nga bind ci kanam. Nimero carte, IBAN, e-mail ak telefon, ñu tëj leen fa, ngir sa kaaraange.",
    "trust.docs.0": "Say documents dañuy des ci sutura",
    "trust.docs.1": "Yow ak équipe vérification Toukky rekk ñoo leen di gis. Duñu leen mukk siiwal, te ñu saytu bu nekk.",
    "faq.title": "Say laaj, balaa ngay tàmbali",
    "faq.lead": "Am nga benn laaj balaa ngay tàmbali ? Assistance partenaires bi dina la tontu.",
    "faq.help": "Ndimbal",
    "faq.items.0.0": "Naka laa war a tàmbalee ?",
    "faq.items.0.1": "Sosal sa compte partenaire, ba noppi waajal sa annonce bu jëkk ci sa espace. Li nga denc dina fa des.",
    "faq.items.1.0": "Ban documents laa war a waajal ?",
    "faq.items.1.1": "Particulier dafay wone ki mu doon (kayitu identité ak selfie) bi muy yónnee annonce bu jëkk bu dalukaay, oto walla taxi. Entreprise dafay jox registre du commerce ak justificatif d'adresse. Oto walla taxi, dañuy laaj carte grise ak attestation d'assurance.",
    "faq.items.2.0": "Ban nataal laa war a yokk ?",
    "faq.items.2.1": "Ay nataal yu leer, ci JPG, PNG walla WEBP, bu weesuwul 8 Mo te bu tollu lu néew lu néew 1024 × 683 pixels. Dalukaay dafay laaj lu néew lu néew ñeent.",
    "faq.items.3.0": "Ban commission lay dox ?",
    "faq.items.3.1": "Taux bi dafa aju ci catégorie bi ak sa contrat. Benn pourcentage bu fi nekk du wuutu sàrt yi ngeen dëggoo ak Toukky.",
    "faq.items.4.0": "Kañ lañu may fey ?",
    "faq.items.4.1": "Sa xaalis dañu koy bayyi bu service bi jeexee, ba noppi ñu yónnee la ko. Onglet Finances dina wone, ci bépp réservation, ndax mu ngi ñëw, mu ngi xaar walla ñu yónnee ko ba noppi.",
    "faq.items.5.0": "Kañ la sama annonce di feeñ ?",
    "faq.items.5.1": "Ginnaaw bi Toukky saytoo sa dossier ak sa annonce. Ci sa espace ngay topp fu mu tollu ak li ñu la laaj nga soppi.",
    "faq.items.6.0": "Ndax mën naa liggéeyandoo ak yeneen nit ?",
    "faq.items.6.1": "Waaw. Ku nekk ci équipe bi am na rôle (gestionnaire, réservations, finances walla opérations) te dafay gis li rôle bi may rekk. Ngir yokk walla dindi kenn, jokkool ak Toukky.",
    "faq.items.7.0": "Naka laa mën a am ndimbal ?",
    "faq.items.7.1": "Jëfandikool « Aide » ngir jokkoo ak Toukky ci sa compte, benn annonce walla benn réservation.",
    "end.title": "Ndax pare nga ngir dalal say tukkikat yu jëkk ?",
    "end.lead": "Sosal sa compte, ba noppi waajal sa annonce ci sa doxin : Toukky dina ko saytu ak yow balaa muy génn.",
    "end.already": "Bokk nga ba noppi ci partenaires Toukky ?",
    "end.access": "Dugg ci espace partenaire",
  },
};

// Paths the French tables no longer have: the tests keep this empty, and the
// site never breaks over one (the French word simply stays).
export const MISSING_WOLOF_PATHS = [];

const copy = (value) => (Array.isArray(value) ? value.map(copy)
  : value && typeof value === "object" ? Object.fromEntries(Object.entries(value).map(([k, v]) => [k, copy(v)])) : value);

const filled = (text) => (arg) => text.replace(/\{(?:n|name)\}/g, String(arg));

/** The French table with the Wolof paths in place. */
export function withWolof(fr, paths, table = "") {
  const out = copy(fr);
  for (const [path, text] of Object.entries(paths)) {
    const keys = path.split(".");
    const last = keys.pop();
    const node = keys.reduce((at, key) => (at && typeof at === "object" ? at[key] : undefined), out);
    if (!node || typeof node !== "object" || !(last in node)) { MISSING_WOLOF_PATHS.push(`${table}:${path}`); continue; }
    node[last] = typeof node[last] === "function" ? filled(text) : text;
  }
  return out;
}

/** A first-name greeting in Wolof. */
export const wolofGreeting = filled(WOLOF.greeting);
